import { useState } from 'react';
import styled       from "@emotion/styled";
import PageWeb from "components/layout/PageWeb"

import LinkNavigator from "components/ui/LinkTo";

import Myinformation from "./Info/MyInformation";
import Subscribe     from "./Info/SusbcribeInfo";
import OrderDelvery  from "./Info/OrderDeliveryInfo";
import Coupon        from "./Info/CouponInfo"
import Notice         from "./Info/NoticeInfo";
import Settings      from "./Info/SettingInfo";
import Footer from 'components/layout/Footer';


const Elem:React.FC<any> = () => {
  const [tab, setTab] = useState(1);
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (index:number) => {
    setTab(index)
    setActiveTab(index)
  }
  
  return (
    <>
      <PageWeb disable={false}>
        <Container>
          <SubHeader>
            <BaseContainer>
              <RemaingDayBox><span>D-Day</span></RemaingDayBox>
              <LastestUploadDateBox>
              <span>포티페타를 체험해 보세요.</span>
            </LastestUploadDateBox>
          </BaseContainer>
        </SubHeader>
        <SecondContainer>
          <NavigationItemsWrapper>
            <LinkNavigator />
          </NavigationItemsWrapper>
          <ContentsContainer>
            <TapContainer className='tab-list'>
              <TapWrapper
                className={activeTab === 1? "tab active" : "tab"}
                //@ts-ignore
                isSeleted={tab ===1}
                onClick={() => handleTabClick(1)}
              >
              내 정보 관리
              </TapWrapper>
              <TapWrapper
              className={activeTab === 2? "tab active" : "tab"}
              //@ts-ignore
              isSeleted={tab ===2}
              onClick={() => handleTabClick(2)}
              >
              구독 정보
              </TapWrapper>
              <TapWrapper
                className={activeTab === 3? "tab active" : "tab"}
                //@ts-ignore
                isSeleted={tab ===3}
                onClick={() => handleTabClick(3)}
              >
                주문/배송 조회
              </TapWrapper>
              <TapWrapper
                className={activeTab === 4? "tab active" : "tab"}
                //@ts-ignore
                isSeleted={tab ===4}
                onClick={() => handleTabClick(4)}
              >
                쿠폰
                </TapWrapper>
              <TapWrapper
                className={activeTab === 5? "tab active" : "tab"}
                //@ts-ignore
                isSeleted={tab ===5}
                onClick={() => handleTabClick(5)}
              >
                공지사항 및 이벤트
              </TapWrapper>
              <TapWrapper
                className={activeTab === 6? "tab active" : "tab"}
                //@ts-ignore
                isSeleted={tab ===6}
                onClick={() => handleTabClick(6)}
              >
                계정 설정
              </TapWrapper>
            </TapContainer>
            <TapContextContainer>
              {tab === 1 && <Myinformation />}
              {tab === 2 && <Subscribe />}
              {tab === 3 && <OrderDelvery />}
              {tab === 4 && <Coupon />}
              {tab === 5 && <Notice />}
              {tab === 6 && <Settings />}
            </TapContextContainer>
          </ContentsContainer>
        </SecondContainer>
      </Container>
    </PageWeb>
    <Footer/>
    </>
  );
};

export default Elem;

const Container = styled.div`
  width: 100%;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BaseContainer = styled.div`
  max-width: 1024px;
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
`;
const FirstContainer = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: column;
  margin-left:auto;
  
  border-top:  1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
`
const SecondContainer = styled.div`
  max-width: 1024px;
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
`;
const NaviContainer = styled.div`
  width: 900px;
  margin: 0 auto;
`
const NavigationItemsWrapper= styled.div`
  width: 300px;
  height: 30px;
  margin-top: 23px;
  margin-bottom: 23px;
  margin-left: auto;
  margin-right: 46px;
`;
const ContentsContainer = styled.div`
  width: 100%;
  /* margin-top: 26px; */
  min-height: 60vh;
  display: flex;
  flex-direction: row;
  margin: 26px auto;
`
const TapContainer = styled.div`
  width: 270px;
  height: 352px;
  display: flex;
  flex-direction: column;
`
const TapWrapper = styled.div`
  width: 100%;
  height: 59px;
  padding-top: 16px;
  padding-left: 23px;
  
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;  
  
  &.active {
    background-color: var(--light-grey);
    border-radius: 0px 30px 29.5px 0px;
  }
`

const TapContextContainer = styled.div`
  margin: 0 auto;
`

const SubHeader = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: row;
  background-color: rgba(217, 217, 217, 0.12);
  border-top: 0.5px solid #D5D5D5;
  border-bottom: 1px solid #D5D5D5;
  align-items: center;
`;
const RemaingDayBox = styled.div`
  height: 100%;
  width: 63px;
  background-color: black;
  display: flex;

  span {
    color: var(--white);
    margin:  auto;
  }
`;
const LastestUploadDateBox = styled.div`
  height: 100%;
  margin-left: auto ;
  padding-right: 14px;
  display: flex;
  align-items: center;

  span {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    display: flex;
    color: #797979;
    /* margin-top: 9px; */
    margin-left: auto;
  }
`;